import React, {useEffect, useRef, useState} from 'react';
import {ADD_STATE, REMOVE_STATE, setItem} from "../../../../redux/actions/generics/IndexedActions";
import {connect, useSelector} from "react-redux";
import {getStateByPath} from "../../../../redux/selectors";
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";
import {dishDrinkService} from "../../../../jwt/_services/ayb/dishDrinkService";
import { Row, Spinner} from "reactstrap";
import {
    TT_EDIT, TT_REMOVE,
} from "../../../../components/i18n/toolTips";
import {GenericButton} from "../../../../components/buttons/customButtons";
import {DragDropList} from "../../../../components/draggableList/DragDropList";
import {SauserSectionForm} from "./_form";
import CustomSwitch from "../../../../components/customSwitch/CustomSwitch";
import {SauserSectionPrices} from "./_prices";
import TranslateButton from "../../../../components/buttons/TranslateButton";
import {TreatmentSectionPrices} from "./_treatmentPrices";
import Separator from "../../../../components/Separator";

const SausersSection = (props) => {
    const path = props?.path + '/items';

    const parentComponentState = useSelector(state => getStateByPath(state, props?.path));
    const componentState = useSelector(state => getStateByPath(state, path));

    const {app, category, domainObject} = parentComponentState?.data || {};
    const {listDomainObjects} = componentState?.data || [];
    const {loading} = componentState?.data || false;
    const fbDataBase = {id: app?.fbDataBase?.id}

    const [categories, setCategories] = useState(domainObject?.categories || []);
    const [categorizedItems, setCategorizedItems] = useState([]);
    const [selectedIndex, setSelectedIndex] = useState(0);

    // Modal para agregar/editar platillos
    const [showSauserModal, setShowSauserModal] = useState(true);
    const sauserModalRef = useRef(null);

    // Modal para agregar/editar precios de platillos
    const [showSauserPricesModal, setShowSauserPricesModal] = useState(true);
    const sauserPricesModalRef = useRef(null);

    // Modal para agregar/editar precios de tratamientos
    const [showTreatmentPricesModal, setShowTreatmentPricesModal] = useState(true);
    const treatmentPricesModalRef = useRef(null);

    const showSauserForm = (item, index, category) => {
        setShowSauserModal(true);
        sauserModalRef.current.showModal(item, index, category);
    }

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);

    useEffect(() => {
        if (!componentState?.path || !app?.id || !domainObject?.id)
            return;

        refreshList();
    }, [ componentState?.path, app, domainObject ]);
    
    useEffect(() => {
        if (!listDomainObjects || listDomainObjects.length === 0) return;

        mapItemsToCategoryItems(listDomainObjects);
    }, [listDomainObjects]);

    const mapItemsToCategoryItems = (_listItems) => {
        const groupedItems = [];

        for (const item of _listItems) {
            const category = groupedItems.find(c => c?.category?.id === item?.category?.id);

            const menuCategory = categories.find(c => c?.category?.id === item?.category?.id && c?.menu?.id === domainObject?.id);

            if (!category) {
                groupedItems.push({
                    id: menuCategory?.id || null,
                    category : { id : item?.category?.id },
                    menu: { id : domainObject?.id },
                    name: item.categoryName,
                    showOrder: menuCategory?.showOrder || groupedItems.length,
                    items: [item],
                });
            } else {
                category.items.push(item);
            }
        }

        groupedItems.map(group => group.items.sort((a, b) => a.showOrder - b.showOrder));

        setCategorizedItems(groupedItems.sort((a, b) => a.showOrder - b.showOrder));

        if (groupedItems.length === 1) {
            groupedItems[0].isOpen = true;
            setSelectedIndex(0);
        }

        groupedItems[selectedIndex].isOpen = true;
    };

    const refreshList = () => {
        const dataRequest = {
            fbDataBase : { id : app?.fbDataBase?.id },
            item : { aybMenu : { id : domainObject?.id } }
        }

        genericIndexedActions.search(path, dishDrinkService, 0, 1000, dataRequest)
    }
    const notImplemented = (item) => {
        console.log(item)
    }

    const onAddSauser = (index) => {
        showSauserForm(null, index);
    }
    const onAddAtCategorySauser = (category, index) => {
        const _item = {
            category : { id : category.id }
        }

        showSauserForm(_item, index);
    }

    const onEditSauser = (item, index) => {
        setItem(path, item)
        showSauserForm(item, index);
    }

    const onDeleteSauser = (item, index) => {
        genericIndexedActions.delete(path, dishDrinkService, item.id, app?.fbDataBase?.id)
    }

    const onEditSauserPrices = (item, index) => {
        setShowSauserPricesModal(true);
        sauserPricesModalRef.current.showModal(item, index);
    }

    const onEditTreatmentPrice = (item, index) => {
        setShowTreatmentPricesModal(true);
        treatmentPricesModalRef.current.showModal(item, index);
    }

    const onReorderSauser = (reorderProps) => {
        // Crear una copia de listDomainObjects para evitar mutaciones directas
        let updatedListDomainObjects = [...listDomainObjects];
        let dataRequest = {
            fbDataBase:  { id : app?.fbDataBase?.id },
            items: []
        }

        for (const reorderedItem of reorderProps.list) {
            // Validar si el ítem tiene un id (es decir, si existe en la base de datos)
            if (reorderedItem.id) {
                // Buscar el ítem en listDomainObjects
                let domainObject = updatedListDomainObjects.find(domainObject => domainObject.id === reorderedItem.id);

                if (domainObject && domainObject.showOrder !== reorderedItem.showOrder) {
                    dataRequest.items.push({
                        id: domainObject.id,
                        showOrder: reorderedItem.showOrder
                    })
                }

            }
        }

        genericIndexedActions.reorder(path, dishDrinkService, dataRequest)
    }

    const sortItemsBySubCategory = (_items) => {
        if (!_items) return [];

        // Sort items by item.subCategoryName then item.showOrder
        return _items.sort((a, b) => {
            if (a.subCategoryName === b.subCategoryName) {
                return a.showOrder - b.showOrder;
            }

            return a.subCategoryName.localeCompare(b.subCategoryName);
        });
    }


    const onReorderCategories = (reorderProps) => {
        setCategorizedItems(reorderProps.list);
        let updatedListCategories = [...categories];

        let dataRequest = {
            fbDataBase:  { id : app?.fbDataBase?.id },
            item: {
                id : domainObject?.id,
                categories: []
            }
        }

        for (const reorderedItem of reorderProps.list) {
            // Validar si el ítem tiene un id (es decir, si existe en la base de datos)
            if (reorderedItem.id) {
                // Buscar el ítem en listDomainObjects
                let menuCategory = updatedListCategories.find(domainObject => domainObject.id === reorderedItem.id);

                dataRequest.item.categories.push({
                    id: menuCategory.id,
                    showOrder: reorderedItem.showOrder
                })
            } else {
                dataRequest.item.categories.push({
                    menu: { id : domainObject.id },
                    category: { id : reorderedItem?.category?.id },
                    showOrder: reorderedItem.showOrder
                })
            }
        }

        setCategories(reorderProps.list);
        props.onUpdateMenuCategories(domainObject.id,dataRequest);
    }

    const selectCategory = (_index) => {
        let _categorizedItems = categorizedItems.slice()

        _categorizedItems.map((item, index) => {
            if (index === _index) {
                item.isOpen = true
            } else {
                item.isOpen = false
            }
        })

        setCategorizedItems(_categorizedItems)
        setSelectedIndex(_index)
    }

    const renderContent = (item, index) => {
        const lbl = categorizedItems[index]?.name || '---'

        return (
            <CustomSwitch
                onClick={_ => { selectCategory(index) }}
                label={ lbl?.toUpperCase().replace('_', ' ') }
                checked={ categorizedItems[index].isOpen }
            />
        )
    }
    const renderSauser = (item, index) => {
        const url = item.mediaUrl;

        return (
            <div className={'sauser-item' + (item.status ? '' : ' innactive' )}>
                <h4>{index + 1}</h4>
                <h4>{item.subCategoryName}</h4>
                {
                    url !== undefined && url !== null ?
                        <img className="item-image" src={url}
                             alt={item.title}
                             width={120}
                             height={120}
                        /> : null
                }
                <label className="sauser-item-title">{item.title}</label>
                <div className="float-left">
                    <GenericButton
                        style={'table'}
                        toolTip={TT_EDIT}
                        icon={'fa-pen'}
                        permission={'edit'}
                        onClick={_ => onEditSauser(item, index)}/>

                    {
                        (category === 'REST' || category === 'HCDP_CUISINE;HCDP_BAR;HCDP_INSIDE_HOUSE') ? <GenericButton
                                style={'table'}
                                toolTip={'Precios'}
                                icon={'fa fa-money'}
                                permission={'edit'}
                                onClick={_ => onEditSauserPrices(item, index)}/> :
                            (category === 'XPA' || category === 'HCDP_SPA') ? <GenericButton
                                style={'table'}
                                toolTip={'Precios'}
                                icon={'fa fa-money'}
                                permission={'edit'}
                                onClick={_ => onEditTreatmentPrice(item, index)}/> : null
                    }
                    <TranslateButton
                        item={item}
                        path={props.path} service={dishDrinkService} askForConfirmation={ false } />
                    <GenericButton
                        style={'danger-secondary'}
                        toolTip={TT_REMOVE}
                        icon={'fa-minus'}
                        permission={'delete'}
                        onClick={() => onDeleteSauser(item)}
                    />
                </div>
            </div>
        )
    }


    const translateAllDishAndDrinks = () => {
        const requestData = {
            db: fbDataBase?.id,
            app: app?.id,
        }

        genericIndexedActions.translateAllDishDrinkInMenu(path, dishDrinkService, domainObject?.id,  requestData)
    }


    return (
        <>
            <div className={'generic-sortable-container'}>
                {
                    props.showHeader && <div className={'generic-sortable-container-header'}>
                        <h2>{'Platillos/Tratamientos'}</h2>

                        <div className={'top-right-header'}>
                            <GenericButton
                                style={'warning-secondary'}
                                label={'Traducir A&B'}
                                toolTip={'Traducir A&B'}
                                icon={ 'fa-language' }
                                permission={'delete'}
                                loading={false}
                                onClick={ translateAllDishAndDrinks }/>
                            <Separator/>
                            <GenericButton
                                style={'table'}
                                label={'Nuevo'}
                                toolTip={'Agrega un nuevo platillo/tratamiento'}
                                icon={'fa-plus'}
                                permission={'add'}
                                onClick={_ => onAddSauser(0)}
                            />
                        </div>
                    </div>
                }
                <div className={'generic-sortable-container-list'}>
                    {
                        loading ? <Spinner animation="border"/> :
                            <>
                                {
                                    categorizedItems.length === 0 ?
                                        <div className={'sauser-add'}>
                                            <h4>{'No hay platillos registrados'}</h4>
                                            <GenericButton
                                                style={'success-secondary'}
                                                label={'Agregar'}
                                                toolTip={'Agrega un nuevo platillo/tratamiento'}
                                                icon={'fa-plus'}
                                                permission={'add'}
                                                onClick={_ => onAddSauser(0)}
                                            />
                                        </div> :
                                        <div>
                                            <Row className={'sauser-container-header'}>
                                                <DragDropList
                                                    items={categorizedItems}
                                                    renderContent={renderContent}
                                                    onReorder={onReorderCategories}
                                                    orientationHV={'horizontal-container'} // CSS class para orientar los elementos horizontalmente
                                                />
                                            </Row>
                                            <Row>
                                                <DragDropList
                                                    items={sortItemsBySubCategory(categorizedItems[selectedIndex]?.items || [])}
                                                    renderContent={renderSauser}
                                                    onReorder={onReorderSauser}
                                                    orientationHV={'vertical-container'} // CSS class para orientar los elementos horizontalmente horizontal-container, vertical-container, ruby-text-container
                                                />
                                                <div className={'sauser-add'}>
                                                    {/*<h4>{categorizedItems[selectedIndex]?.items?.length + 1}</h4>*/}
                                                    {/*<label className="menu_item_title">{'Agregar en: ' + categorizedItems[selectedIndex]?.name + '  '}</label>*/}
                                                    <GenericButton
                                                        style={'success-secondary'}
                                                        label={'Agregar en: ' + categorizedItems[selectedIndex]?.name + ''}
                                                        toolTip={'Agrega un nuevo platillo en: ' + categorizedItems[selectedIndex]?.name}
                                                        icon={'fa-plus'}
                                                        permission={'add'}
                                                        onClick={_ => onAddAtCategorySauser({
                                                            id: categorizedItems[selectedIndex]?.category?.id,
                                                            name: categorizedItems[selectedIndex]?.name
                                                        }, categorizedItems[selectedIndex]?.items?.length)}/>

                                                </div>
                                            </Row>
                                        </div>
                                }
                            </>
                    }
                </div>
            </div>
            {
                showSauserModal && <SauserSectionForm
                    path={path}
                    parent={domainObject}
                    app={app}
                    category={category}

                    ref={sauserModalRef}
                />
            }
            {
                showSauserPricesModal && <SauserSectionPrices
                    path={path}
                    parent={domainObject}
                    app={app}
                    category={category}

                    refreshList={refreshList}

                    ref={sauserPricesModalRef}
                />
            }
            {
                showTreatmentPricesModal && <TreatmentSectionPrices
                    path={path}
                    parent={domainObject}
                    app={app}
                    category={category}

                    refreshList={refreshList}

                    ref={treatmentPricesModalRef}
                />
            }
        </>
    );
}

SausersSection.propTypes = {

};

const mapStateToProps = _ => ({})

const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
    setItem
})

export default connect(mapStateToProps, mapActionsToProps)(SausersSection)